import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import { StyledSwitch } from 'framework/ui/layout';
import { useInputHelper } from 'framework/form';

type ActionRequiredTogglerProps = {
  source: string;
  label?: React.ReactNode;
  disabled?: boolean;
};

const ApprovalRequiredToggler = ({
  source,
  disabled = false,
  label = 'Approval required',
}: ActionRequiredTogglerProps) => {
  const { getValue, getRawOnChangeCallback } = useInputHelper({ source });

  const currentValue = getValue();
  const rawOnChangeCallback = getRawOnChangeCallback();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (rawOnChangeCallback) {
      rawOnChangeCallback({
        [source]: e.target.checked,
      });
    }
  };

  return (
    <FormControlLabel
      disabled={disabled || false}
      control={
        <StyledSwitch
          className="settings__switch"
          color="primary"
          checked={currentValue || false}
          onChange={handleChange}
          dataOff="No"
          dataOn="Yes"
          name={source}
        />
      }
      label={label}
    />
  );
};

export default ApprovalRequiredToggler;
